module.exports = __webpack_public_path__ + "static/img/top1.c8a33a64.png";